"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Labels = /** @class */ (function () {
    function Labels(containers, idCanvas, idInputFont, idBtnBold, idBtnItalic, idBtnUndeline, idInputFile, idFontSize, classButtonActive) {
        if (idCanvas === void 0) { idCanvas = 'box'; }
        if (idInputFont === void 0) { idInputFont = 'fonts'; }
        if (idBtnBold === void 0) { idBtnBold = 'bold'; }
        if (idBtnItalic === void 0) { idBtnItalic = 'italic'; }
        if (idBtnUndeline === void 0) { idBtnUndeline = 'underline'; }
        if (idInputFile === void 0) { idInputFile = 'file'; }
        if (idFontSize === void 0) { idFontSize = 'fontSize'; }
        if (classButtonActive === void 0) { classButtonActive = ['active']; }
        this.classButtonActive = [];
        if (idCanvas) {
            this.canvas = new fabric.Canvas(idCanvas);
            this.canvasDOM = document.getElementById(idCanvas);
        }
        if (idInputFont) {
            this.inputFont = document.getElementById(idInputFont);
        }
        if (idFontSize) {
            this.idFontSize = document.getElementById(idFontSize);
        }
        this.btnBold = document.getElementById(idBtnBold);
        if (idBtnItalic) {
            this.btnItalic = document.getElementById(idBtnItalic);
        }
        if (idBtnUndeline) {
            this.btnUndeline = document.getElementById(idBtnUndeline);
        }
        if (idInputFile) {
            this.inputFile = document.getElementById(idInputFile);
        }
        if (classButtonActive) {
            this.classButtonActive = classButtonActive;
        }
        if (containers) {
            this.containers = containers;
        }
        this.start();
        this.activeButtonsAndFile();
        // console.log(this.canvas, this.canvasDOM.style);
    }
    // intitialized Class Label
    Labels.prototype.start = function () {
        this.canvasDOM.style.border = "1px dotted rgba(0,0,0,0.3)";
        this.canvasDOM.style.borderRadius = "5px";
        if (this.containers) {
            for (var _i = 0, _a = this.containers; _i < _a.length; _i++) {
                var container = _a[_i];
                this.canvas.add(container);
            }
        }
    };
    // active function buttons if exist in paramater
    // @ts-ignore
    Labels.prototype.activeButtonsAndFile = function () {
        var _this = this;
        if (!this.canvas)
            return;
        if (this.btnUndeline) {
            this.btnUndeline.addEventListener('click', function (e) {
                var active = _this.canvas.getActiveObject();
                if (!active)
                    return;
                if (!active.styles || !active.styles[0] || !active.styles[0][active.selectionStart] || !active.styles[0][active.selectionStart].underline) {
                    active.setSelectionStyles({ underline: true });
                }
                else {
                    var falsee = 0, truee = 0;
                    for (var i = active.selectionStart; i < active.selectionEnd; i++) {
                        if (!active.styles || !active.styles[0] || !active.styles[0][i] || !active.styles[0][i].underline) {
                            falsee++;
                        }
                        else {
                            truee += active.styles[0][i].underline ? 1 : 0;
                        }
                    }
                    var done = truee >= falsee ? true : false;
                    active.setSelectionStyles({ underline: !done });
                }
                _this.canvas.requestRenderAll();
            });
        }
        if (this.btnBold) {
            this.btnBold.addEventListener('click', function (e) {
                // console.log(this.canvas.getActiveObject())
                var active = _this.canvas.getActiveObject();
                if (!active)
                    return;
                if (!active.styles || !active.styles[0] || !active.styles[0][active.selectionStart] || !active.styles[0][active.selectionStart].fontWeight) {
                    active.setSelectionStyles({ fontWeight: 'bold' });
                }
                else {
                    var falsee = 0, truee = 0;
                    for (var i = active.selectionStart; i < active.selectionEnd; i++) {
                        if (!active.styles || !active.styles[0] || !active.styles[0][i] || active.styles[0][i].fontWeight != 'bold') {
                            falsee++;
                        }
                        else {
                            truee += active.styles[0][i].fontWeight ? 1 : 0;
                        }
                    }
                    var done = truee >= falsee ? true : false;
                    active.setSelectionStyles({ fontWeight: !done ? 'bold' : 'normal' });
                }
                // active.setSelectionStyles({ fontWeight: this.canvas.getActiveObject().fontWeight != 'bold' ? 'bold' : 'normal' });
                _this.canvas.requestRenderAll();
            });
        }
        if (this.btnItalic) {
            this.btnItalic.addEventListener('click', function (e) {
                var active = _this.canvas.getActiveObject();
                if (!active)
                    return;
                if (!active.styles || !active.styles[0] || !active.styles[0][active.selectionStart] || !active.styles[0][active.selectionStart].fontStyle) {
                    active.setSelectionStyles({ fontStyle: 'italic' });
                }
                else {
                    var falsee = 0, truee = 0;
                    for (var i = active.selectionStart; i < active.selectionEnd; i++) {
                        if (!active.styles || !active.styles[0] || !active.styles[0][i] || active.styles[0][i].fontStyle != 'italic') {
                            falsee++;
                        }
                        else {
                            truee += active.styles[0][i].fontStyle ? 1 : 0;
                        }
                    }
                    var done = truee >= falsee ? true : false;
                    active.setSelectionStyles({ fontStyle: !done ? 'italic' : 'normal' });
                }
                _this.canvas.requestRenderAll();
            });
        }
        // on change input select form
        if (this.inputFont) {
            this.inputFont.addEventListener('change', function (e) {
                var active = _this.canvas.getActiveObject();
                if (!active)
                    return;
                active.setSelectionStyles({ fontFamily: e.target.value });
                _this.canvas.requestRenderAll();
            });
        }
        if (this.idFontSize) {
            this.idFontSize.addEventListener('change', function (e) {
                var active = _this.canvas.getActiveObject();
                if (!active)
                    return;
                active.setSelectionStyles({ fontSize: e.target.value });
                _this.canvas.requestRenderAll();
            });
        }
        if (this.containers) {
            this.canvas.on('selection:updated', function () {
                console.log(_this.canvas.getActiveObject());
            });
        }
    };
    return Labels;
}());
// let containers = [
//   new fabric.IText('hola', {
//     fontSize: 20,
//     left: 0,
//     top: 0
//   }),
//   new fabric.IText('hola', {
//     fontSize: 20,
//     left: 0,
//     top: 0
//   }),
//   new fabric.IText('hola', {
//     fontSize: 20,
//     left: 0,
//     top: 0
//   }),
// ]
// let labels = new Labels([...containers], 'box', 'fonts', 'bold', 'italic', 'underline', 'backround', 'fontSize', ['active'])
exports.default = Labels;
